const SEM = { verde: "#2e9e4f", amarillo: "#e0a800", rojo: "#d23b2f" };
const fmt = (n, d = 0) => (n ?? 0).toLocaleString("es-PY", { maximumFractionDigits: d });
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export function Semaforo({ nivel, texto }) {
  return <span className="inline-flex items-center gap-1" data-testid="clima-semaforo"><span className="inline-block w-2.5 h-2.5 rounded-full" style={{ background: SEM[nivel] || "#999" }} />{texto}</span>;
}

function LluviaBarras({ mensual }) {
  const max = Math.max(1, ...mensual.flatMap((m) => [m.mm, m.normal]));
  return (
    <div className="flex items-end gap-2 h-24 mt-1" data-testid="clima-barras">
      {mensual.map((m) => <div key={m.mes} className="flex-1 flex flex-col items-center gap-0.5">
        <div className="flex items-end gap-0.5 h-20 w-full justify-center">
          <div title={`real ${fmt(m.mm)} mm`} className="w-3 rounded-t bg-sky-600" style={{ height: `${(m.mm / max) * 100}%`, opacity: m.parcial ? 0.6 : 1 }} />
          <div title={`normal ${fmt(m.normal)} mm`} className="w-3 rounded-t bg-slate-400" style={{ height: `${(m.normal / max) * 100}%` }} />
        </div>
        <span className="text-[10px] text-slate-500">{MES[Number(m.mes.slice(5, 7)) - 1]}{m.parcial ? "*" : ""}</span>
      </div>)}
    </div>
  );
}

export default function ClimaPanel({ clima, compacto }) {
  if (!clima) return <p className="text-xs text-slate-500" data-testid="clima-pendiente">Clima y cultivo: calculando…</p>;
  if (clima.error) return <p className="text-xs text-amber-700" data-testid="clima-error">{clima.error}</p>;
  const a = clima.acumulados, s = clima.semaforo, e = clima.etapa;
  const dev = (x) => x.desvio_pct == null ? "" : `${x.desvio_pct > 0 ? "+" : ""}${x.desvio_pct} %`;
  return (
    <div className="text-xs space-y-1.5" data-testid="clima-panel">
      <div className="font-bold flex items-center gap-2">Clima y cultivo <Semaforo nivel={s.nivel} texto={s.nivel} /></div>
      {s.avisos.map((t, i) => <p key={i} className="font-semibold" style={{ color: SEM[s.nivel] }} data-testid={`clima-aviso-${i}`}>{t}</p>)}
      <p data-testid="clima-etapa"><b>Etapa probable:</b> {e.texto}</p>
      <div className="grid grid-cols-3 gap-1 text-center">
        {["30d", "60d", "90d"].map((k) => <div key={k} className="rounded bg-slate-100 px-1 py-0.5" data-testid={`clima-acum-${k}`}><div className="text-slate-500">{k.replace("d", " días")}</div><b>{fmt(a[k].mm)} mm</b><div className="text-slate-500">normal {fmt(a[k].normal)} · <span style={{ color: Math.abs(a[k].desvio_pct || 0) >= 30 ? SEM.rojo : undefined }}>{dev(a[k])}</span></div></div>)}
      </div>
      {!compacto && <>
        <LluviaBarras mensual={clima.mensual} />
        <p className="text-slate-500">Barras: real (azul) vs normal 1991–2020 (gris) · * mes en curso</p>
        <p><b>Próximos 7 días:</b> {fmt(s.lluvia_7d)} mm · {clima.pronostico.slice(0, 7).map((d) => `${d.fecha.slice(8)}/${d.fecha.slice(5, 7)} ${fmt(d.tmin)}–${fmt(d.tmax)}°${d.mm >= 10 ? ` ☂${fmt(d.mm)}` : ""}`).join(" · ")}</p>
        <p className="text-slate-500">{clima.fuente} · {e.fuente} · Umbrales: {s.umbrales}</p>
      </>}
    </div>
  );
}
